import { render, staticRenderFns } from "./GroupParty.vue?vue&type=template&id=51f57656&scoped=true&lang=pug"
import script from "./GroupParty.vue?vue&type=script&lang=js"
export * from "./GroupParty.vue?vue&type=script&lang=js"
import style0 from "./GroupParty.vue?vue&type=style&index=0&id=51f57656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f57656",
  null
  
)

export default component.exports